import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiAward, FiUsers, FiTrendingUp, FiShield } = FiIcons;

const About = () => {
  const stats = [
    {
      icon: FiUsers,
      number: '50+',
      label: 'Happy Clients'
    },
    {
      icon: FiTrendingUp,
      number: '25+',
      label: 'Years Experience'
    },
    {
      icon: FiAward,
      number: '100%',
      label: 'Accuracy Rate'
    },
    {
      icon: FiShield,
      number: 'Available',
      label: 'Business Consultation Support'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About Sue Rodriguez
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              With over 25 years of experience in bookkeeping and accounting, Sue Rodriguez is a Certified QuickBooks Pro Advisor dedicated to helping businesses maintain accurate financial records and achieve their financial goals.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              At Wisdomwares, LLC, we believe that proper bookkeeping is the foundation of a successful business. Our personalized approach ensures that each client receives the attention and expertise they deserve.
            </p>

            {/* QuickBooks Badge */}
            <div className="flex flex-col sm:flex-row items-center gap-6 mb-8 p-6 bg-blue-50 rounded-lg">
              <div className="w-40 h-40 relative flex-shrink-0">
                <img 
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752510277763-Pro%20Advisor.png"
                  alt="QuickBooks Pro Advisor Badge"
                  className="w-full h-full object-contain"
                />
              </div>
              
              <div className="flex-1">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Certifications & Qualifications
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-center space-x-3">
                    <SafeIcon icon={FiAward} className="h-5 w-5 text-blue-600" />
                    <span className="text-gray-700">Certified QuickBooks Pro Advisor</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <SafeIcon icon={FiAward} className="h-5 w-5 text-blue-600" />
                    <span className="text-gray-700">Licensed Business Professional</span>
                  </li>
                  <li className="flex items-center space-x-3">
                    <SafeIcon icon={FiAward} className="h-5 w-5 text-blue-600" />
                    <span className="text-gray-700">Continuing Education Certified</span>
                  </li>
                </ul>
              </div>
            </div>

            <a
              href="#contact"
              className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 inline-block"
            >
              Schedule a Consultation
            </a>
          </motion.div>

          {/* Stats */}
          <motion.div
            className="grid grid-cols-2 gap-6"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            {stats.map((stat, index) => (
              <motion.div
                key={stat.label}
                className="bg-gradient-to-br from-blue-50 to-white rounded-xl p-6 text-center shadow-lg"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.05 }}
              >
                <div className="bg-blue-100 rounded-lg p-3 w-fit mx-auto mb-4">
                  <SafeIcon icon={stat.icon} className="h-8 w-8 text-blue-600" />
                </div>
                <div className="text-3xl font-bold text-gray-900 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">
                  {stat.label}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;